/*eslint-disable*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
// style for this view
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";

const useStyles = makeStyles(styles);
const useStyleData = makeStyles(stylesData);
export default function ResetPassword() {
  const [registerPassword, setregisterPassword] = React.useState("");
  const [alertView, setAlertView] = React.useState(null);
  const [registerPasswordState, setregisterPasswordState] = React.useState("");
  const [registerConfirmPassword, setregisterConfirmPassword] = React.useState(
    ""
  );
  const [registerNewPassword, setregisterNewPassword] = React.useState("");
  const [
    registerConfirmPasswordState,
    setregisterConfirmPasswordState,
  ] = React.useState("");
  const [
    registerNewPasswordState,
    setregisterNewPasswordState,
  ] = React.useState("");

  const verifyLength = (value, length) => {
    if (value.length >= length) {
      return true;
    }
    return false;
  };
  const hideAlert = () => {
    setAlertView(null);
  };
  const handleSubmit = async (e) => {
    console.log("handle password exicuted");

    e.preventDefault();
    let payload = {
      oldPassword: registerPassword,
      newPassword: registerNewPassword,
      confirmPassword: registerConfirmPassword,
    };
    console.log(payload,"payload");
    
    let token = localStorage.getItem("token");
    if (registerConfirmPassword === registerNewPassword) {
      let response = await axios
        .put(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/resetpassword`,
          payload,
          {
            headers: {
              authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          if (typeof response.data == "string") {
            if (response.data === "Password updated successfully") {
              setSuccessMessage(response.data.message);
              setAlertView(
                <SweetAlert
                  style={{ display: "block", marginTop: "-100px" }}
                  title={response.data.message}
                  onConfirm={() => hideAlert()}
                  onCancel={() => hideAlert()}
                  confirmBtnCssClass={
                    classesSweetAlert.button + " " + classesSweetAlert.success
                  }
                />
              );
              setTimeout(() => {
                navigate("/admin/dashboard");
              }, 2000);
            } else setError(response.data.message);
          }
        })
        .catch((err) => {
          setAlertView(
            <SweetAlert
              style={{ display: "block", marginTop: "-100px" }}
              title={"Invalid Password"}
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnCssClass={
                classesSweetAlert.button + " " + classesSweetAlert.success
              }
            />
          );
        });
    } else {
      alert("Password doesn't match");
    }
    console.log(payload);
  };
  const classesSweetAlert = useStyleData();
  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem
        xs={12}
        sm={12}
        md={12}
        styles={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Reset Password</h4>
          </CardHeader>
          <CardBody>
            <form>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    success={registerPasswordState === "success"}
                    error={registerPasswordState === "error"}
                    labelText="Old Password *"
                    id="registerOldpassword"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    handleChange={(event) => {
                      if (verifyLength(event.target.value, 1)) {
                        setregisterPasswordState("success");
                      } else {
                        setregisterPasswordState("error");
                      }
                      setregisterPassword(event.target.value);
                    }}
                    inputProps={{
                      type: "password",
                      autoComplete: "off",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    success={registerNewPasswordState === "success"}
                    error={registerNewPasswordState === "error"}
                    labelText="New Password *"
                    id="registerpassword"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    handleChange={(event) => {
                      if (verifyLength(event.target.value, 1)) {
                        setregisterNewPasswordState("success");
                      } else {
                        setregisterNewPasswordState("error");
                      }
                      setregisterNewPassword(event.target.value);
                    }}
                    inputProps={{
                      type: "password",
                      autoComplete: "off",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    success={registerConfirmPasswordState === "success"}
                    error={registerConfirmPasswordState === "error"}
                    labelText="Confirm Password *"
                    id="registerConfirmpassword"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    handleChange={(event) => {
                      if (verifyLength(event.target.value, 1)) {
                        setregisterConfirmPasswordState("success");
                      } else {
                        setregisterConfirmPasswordState("error");
                      }
                      setregisterConfirmPassword(event.target.value);
                    }}
                    inputProps={{
                      type: "password",
                      autoComplete: "off",
                    }}
                  />
                </GridItem>
              </GridContainer>

              <Button
                color="rose"
                onClick={handleSubmit}
                className={classes.registerButton}
              >
                Reset Password
              </Button>
            </form>
            {alertView}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
